const MINUTE_MS = 60_000;
const HOUR_MS = 60 * MINUTE_MS;
const DAY_MS = 24 * HOUR_MS;

/** Compact age: `now`, `5m`, `3h`, `2d`, then a short date. */
export function relativeTime(thenMs: number, nowMs: number): string {
  if (!Number.isFinite(thenMs)) return '';
  const elapsed = Math.max(0, nowMs - thenMs);
  if (elapsed < MINUTE_MS) return 'now';
  if (elapsed < HOUR_MS) return `${Math.floor(elapsed / MINUTE_MS)}m`;
  if (elapsed < DAY_MS) return `${Math.floor(elapsed / HOUR_MS)}h`;
  if (elapsed < 7 * DAY_MS) return `${Math.floor(elapsed / DAY_MS)}d`;
  return new Date(thenMs).toLocaleDateString(undefined, {
    month: 'short',
    day: 'numeric',
  });
}
